export default {
    users: [],
    editingUser: {},
    selectedUsers: [],

    phones: [],
};
